export const LOAD_BUSINESS_RULES = 'load_business_rules';
export const BUSINESS_RULES_LOADED = 'business_loaded';
export const LOAD_BUSINESS_RULE = 'load_business_rule';
export const BUSINESS_RULE_LOADED = 'business_rule_loaded';
export const BUSINESS_RULE_DELETED = 'business_rule_deleted';
export const LOAD_BUSINESS_RULES_TYPES = 'load_business_rules_types';
export const BUSINESS_RULES_TYPES_LOADED = 'load_business_rules_types_loaded';
export const RESET_BUSINESS_RULES = 'reset_business_rules';
export const RESET_BUSINESS_RULE = 'reset_business_rule';
export const SYNC_FAILED = 'business_rule_sync_has_failed';
export const LOAD_BUSINESS_RULES_ACTION = 'load_business_rules_action';
export const BUSINESS_RULES_ACTION_LOADED = 'business_rules_action_loaded';
export const SAVE_BUSINESS_RULE = 'save_business_rule';
export const BUSINESS_RULES_SAVED = 'business_rules_saved';
export const SET_RULE_ID = 'set_rule_id';
export const RESET_RULE_ID = 'reset_rule_id';
